import { Component, Element, h, Host, Prop, State, Watch } from "@stencil/core";
import { TrumpfNotificationActionLink, TrumpfNotificationType } from "./notification-item";

@Component({
    tag: "ux-notification-text",
    styleUrl: "notification-text.scss",
    shadow: false
})
export class NotificationItem {
    private baseClass = "ux-notification-text";

    /** The host html element. */
    @Element() el!: HTMLUxNotificationTextElement;

    /** The subject of the notification. */
    @Prop() readonly subject: string = "";

    /** Update notification state  */
    @Prop() readonly notificationUpdateError: boolean = false;

    /** Update notification error text */
    @Prop() readonly notificationUpdateErrorText: string = "Update failed. Please try again.";

    /** Link of the notification, e.g. link for read more button */
    @Prop() readonly link: TrumpfNotificationActionLink["link"] = "";

    /** Link text of the notification, e.g. read more */
    @Prop() readonly linkText: TrumpfNotificationActionLink["linkText"] = "";

    /** Type of notification. Can be 'Overview' or 'Detail'. */
    @Prop() readonly type: TrumpfNotificationType = "Detail";

    /** Is the notification text collapsed.  */
    @State() collapsed = true;

    /** Is the notification text too long.  */
    @State() tooLong = false;

    private setTooLong = () => {
        const wrapperDiv = this.el.querySelector(`div.${this.baseClass}__wrapper`);
        // @ts-expect-error Check for typing
        this.tooLong = wrapperDiv.scrollHeight > Math.round(wrapperDiv.getBoundingClientRect().height);
    };

    @Watch("subject")
    @Watch("message")
    onContentChange() {
        this.setTooLong();
    }

    componentDidLoad() {
        this.setTooLong();
    }

    render() {
        const { baseClass, subject, link, linkText, type, notificationUpdateError, notificationUpdateErrorText } = this;

        const toggleCollapsed = (e: MouseEvent) => {
            e.preventDefault();
            this.collapsed = !this.collapsed;
        };

        return (
            <Host>
                <div class={baseClass}>
                    <div
                        class={{
                            [`${baseClass}__wrapper`]: true,
                            [`${baseClass}__wrapper_gradient`]: this.tooLong && this.collapsed,
                            [`${baseClass}__wrapper_expanded`]: !this.collapsed
                        }}
                    >
                        {notificationUpdateError && (
                            <div class={`${baseClass}__error ux-text-normal`}>{notificationUpdateErrorText}</div>
                        )}
                        {type.toLowerCase() === "overview" && (
                            <div class={`${baseClass}__subject ux-text-normal ux-text-normal--bold`}>{subject}</div>
                        )}
                        {type.toLowerCase() === "detail" && (
                            <div class={`${baseClass}__subject ux-text-title ux-text-title--bold`}>{subject}</div>
                        )}
                        {type.toLowerCase() === "overview" && (
                            <div class={`${baseClass}__message ux-text-normal`}>
                                <slot name="message" />
                            </div>
                        )}
                        {type.toLowerCase() === "detail" && (
                            <div class={`${baseClass}__message ux-text-normal`}>
                                <slot name="message" />
                                {link && linkText && (
                                    <a href={link} target="_self" class="ux-text-link ux-text-link--bold ux-text-link--green">
                                        {linkText}
                                        <ux-icon name="arrow-right" weight="normal" />
                                    </a>
                                )}
                            </div>
                        )}
                    </div>
                    {this.tooLong && (
                        <button class="ux-icon-button" onClick={(e) => toggleCollapsed(e)}>
                            <ux-icon class={this.collapsed ? "" : `${baseClass}__icon`} size-s="15" name="chevron-down" />
                        </button>
                    )}
                </div>
            </Host>
        );
    }
}
